<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Key';
                }
            },
            component_id: {
                default(){
                    return 'key';
                }
            },
            hardwareCylinder: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.fabricator, this.hardwareCylinder);
            },
            url(){
                return '/api/options/' + this.fabricator + '/key?hardware_cylinder=' + this.hardwareCylinder;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.hardwareCylinder;
            },
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
